import Icon from 'components/atoms/Icon';
import { getEmptyFormSoftSkillValues } from 'components/feature/jobRole/JobRoleForm/JobRoleForm.helpers';
import { TJobRoleFormValues } from 'components/feature/jobRole/JobRoleForm/JobRoleForm.types';
import FormSoftSkillField from 'components/feature/jobRole/JobRoleFormSoftSkillField/JobRoleFormSoftSkillField';
import { FieldArray, useFormikContext } from 'formik';
import { SoftSkillFragment } from 'generated/graphql';
import { isArray } from 'lodash';
import { FC, useMemo } from 'react';
import { Button } from '@spotted-zebra-uk/ui-components';
import styles from './JobRoleFormSoftSkillFields.module.scss';

interface IJobRoleFormSoftSkillFields {
  openTraitsModal: (softSkillIndex: number) => void;
  traitsModalSoftSkillIndex?: number;
  onCloseTraitsModal: () => void;
  predefinedSoftSkills?: SoftSkillFragment[];
}

const JobRoleFormSoftSkillFields: FC<IJobRoleFormSoftSkillFields> = props => {
  const { values, errors } = useFormikContext<TJobRoleFormValues>();
  const parsedSoftSkillErrors = useMemo(() => {
    if (!errors.softSkills) return;

    if (isArray(errors.softSkills)) {
      return errors.softSkills.join(', ');
    }

    return errors.softSkills;
  }, [errors.softSkills]);
  return (
    <div className={styles.container}>
      <FieldArray
        name="softSkills"
        render={fieldArrayHepleres => (
          <>
            <div className={styles.skillsList}>
              {values.softSkills.map((_softSkillValues, index) => (
                <FormSoftSkillField
                  key={index}
                  index={index}
                  remove={fieldArrayHepleres.remove}
                  {...props}
                />
              ))}
            </div>
            {parsedSoftSkillErrors ? (
              <div className={styles.errorMessage}>{parsedSoftSkillErrors}</div>
            ) : null}
            <div className={styles.actions}>
              <Button
                onClick={() =>
                  fieldArrayHepleres.push(getEmptyFormSoftSkillValues())
                }
                size="medium"
                variant="secondary"
                type="button"
                data-role="add-soft-skill"
                leftIcon={<Icon icon="add_black" className={styles.icon} />}
              >
                Add soft skill
              </Button>
            </div>
          </>
        )}
      />
    </div>
  );
};

export default JobRoleFormSoftSkillFields;
